@if (contentlet$ | async; as contentlet) {
<div class="default-video-class box-video-banner-container position-relative" [ngClass]="bannerVideoWidth(contentlet)">
  @if (buildVideoSrc('fileAsset') | async | dotCmsCodecEncode; as videoSrc) {
  <video
    loop
    width="100%"
    height="100%"
    playsInline
    [src]="videoSrc"
    [autoplay]="contentlet.disableAutoplay ? '' : true"
    [muted]="true"
    class="dotcms-video"
  ></video>
  }
  <div class="video-overlay"></div>
  <div class="video-banner-caption">
    <custom-dot-cms-banner-link
      [animationCss]="(animationTriggered$ | async) ? contentlet.captionAnimation : ''"
      [contentlet]="contentlet"
    />
  </div>
</div>
}
